import { render, staticRenderFns } from "./FamilyForm.vue?vue&type=template&id=8dd5cdda&"
import script from "./FamilyForm.vue?vue&type=script&lang=js&"
export * from "./FamilyForm.vue?vue&type=script&lang=js&"
import style0 from "./FamilyForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports